<template>
  <div v-if="active.length > 0" class="d-flex flex-wrap align-items-center" style="gap: 0.375rem; flex: 1 1 auto; min-width: 0">
    <b-badge
      v-for="filter in active"
      :key="filter.key"
      pill
      variant="primary"
      class="d-inline-flex align-items-center px-75 py-50"
      v-b-tooltip.hover
      :title="`${filter.label}: ${filter.all}`"
    >
      <span>{{ filter.label }}: {{ filter.summary }}</span>
      <feather-icon icon="XIcon" size="12" class="ml-50 cursor-pointer" @click="remove(filter.key)" />
    </b-badge>
    <b-button variant="flat-secondary" size="sm" class="px-50 py-25" @click="$emit('input', {})">Clear all</b-button>
  </div>
</template>

<script>
import { BBadge, BButton, VBTooltip } from 'bootstrap-vue';

// More selected values than this collapse to "N selected" (full list on hover).
const MAX_LISTED = 2;

/**
 * One line summarising the column filters in effect, each removable. The
 * filters themselves are set from the column headers (RosterColumnFilterMenu).
 */
export default {
  name: 'RosterActiveFilters',
  components: { BBadge, BButton },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    /** { [key]: string[] } */
    value: { type: Object, default: () => ({}) },
    /** [{ key, label, options: [{ label, value }] }] */
    filters: { type: Array, required: true },
  },
  emits: ['input'],
  computed: {
    active() {
      return this.filters
        .filter((filter) => (this.value[filter.key] || []).length > 0)
        .map((filter) => {
          const labels = this.value[filter.key].map(
            (selected) => (filter.options.find((option) => option.value === selected) || { label: selected }).label,
          );
          return {
            key: filter.key,
            label: filter.label,
            all: labels.join(', '),
            summary: labels.length > MAX_LISTED ? `${labels.length} selected` : labels.join(', '),
          };
        });
    },
  },
  methods: {
    remove(key) {
      this.$emit('input', { ...this.value, [key]: [] });
    },
  },
};
</script>
